import { render } from "./rental-setting.vue?vue&type=template&id=54adbcf0"
import script from "./rental-setting.vue?vue&type=script&lang=js"
export * from "./rental-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__